import { Box, Text, Image, Layer, Button } from "grommet";

export default function PodImageModal({ selectedImage, closeModal }) {
  if (!selectedImage) return null;

  return (
    <Layer
      full
      modal
      onClickOutside={closeModal}
      onEsc={closeModal}
      background="rgba(0, 0, 0, 0.8)"
    >
      <Box
        fill
        align="center"
        justify="center"
        pad="large"
        onClick={closeModal}
      >
        <Box
          background="white"
          pad="medium"
          round="small"
          onClick={(e) => e.stopPropagation()}
        >
          <Box
            direction="row"
            justify="between"
            align="center"
            margin={{ bottom: "small" }}
          >
            <Text weight="bold" size="large">
              {selectedImage.type}
            </Text>
            <Button
              icon={<span style={{ fontSize: "24px" }}>×</span>}
              onClick={closeModal}
              plain
              hoverIndicator
            />
          </Box>
          <Image
            src={selectedImage.url}
            fit="contain"
            style={{ maxHeight: "80vh", maxWidth: "80vw" }}
          />
        </Box>
      </Box>
    </Layer>
  );
}
